import { cn } from '@forest/shared'
import { For, Show } from 'solid-js'
import defaultAvatar from '~/assets/default-avatar.webp'
import { deriveInviteeStack } from '~/lib/invitees'
import { m } from '~/paraglide/messages'

// Figma "number of invitees" avatar spec: 20px circle, white outside stroke,
// soft drop shadow, −6px overlap; the overflow bubble shares the frame.
const circleClass =
  'size-5 rounded-full border-[1.5px] border-white bg-[#D7D7D7] shadow-[4px_2px_3px_rgba(0,0,0,0.11)]'

export function InvitedPill(props: {
  count: number
  avatars: (string | null)[] | undefined
}) {
  const stack = () => deriveInviteeStack(props.avatars, props.count)
  return (
    <div class="relative z-10 flex justify-center">
      <div class="flex items-center gap-2 rounded-[30px] bg-black/30 px-2 py-1.5 backdrop-blur-2xl">
        <Show when={stack().avatars.length > 0}>
          <div class="flex items-center">
            <For each={stack().avatars}>
              {(avatar, index) => (
                <div class={cn(circleClass, index() > 0 && '-ml-1.5')}>
                  {/* null = invitee with no avatar → default avatar */}
                  <img
                    src={avatar ?? defaultAvatar}
                    alt=""
                    class="size-full rounded-full object-cover"
                  />
                </div>
              )}
            </For>
            <Show when={stack().overflow > 0}>
              <div
                class={cn(
                  circleClass,
                  '-ml-1.5 flex items-center justify-center text-[10px] leading-[14px] text-[#666]',
                )}
              >
                +{stack().overflow}
              </div>
            </Show>
          </div>
        </Show>
        <span
          class="px-1 text-sm text-white"
          // oxlint-disable-next-line solid/no-innerhtml -- translation markup with a numeric param only
          innerHTML={m
            .people_invited({ number: props.count })
            .replace('__STYLE__', 'font-weight: 700;')}
        />
      </div>
    </div>
  )
}
